import { BaseHttpResponseError } from './base-http.error';

/**
 * Error Code: 200 - This error occurs due to generic IO
 */
export class StorageError extends BaseHttpResponseError {
  constructor(err) {
    super(err);
  }
}

/**
 * Error Code: 201 - This error occurs when can’t read meta data files from S3 storage
 */
export class CannotReadS3StorageError extends BaseHttpResponseError {
  constructor(err) {
    super(err);
  }
}

/**
 * Error Code: 202 - This error occurs when can’t write back to the S3 storage (meta data about the export)
 */
export class CannotWriteS3StorageError extends BaseHttpResponseError {
  constructor(err) {
    super(err);
  }
}
